// extracted by mini-css-extract-plugin
export default {"container":"Aging_container__mO1b6","contents":"Aging_contents__+j60i","description":"Aging_description__OxOd7"};